import {NavLink} from 'react-router-dom';
import {INavigationItem} from '../../types';
import s from './navListItem.module.css';

interface INavListItemProps {
    navItem: INavigationItem;
}

export default function NavListItem({navItem}: INavListItemProps) {

    return (
        <li className={s.navItem}>
            <NavLink
                to={navItem.path}
                className={({isActive}) =>
                    isActive ? `${s.navItemLink} ${s.activeItem}` : s.navItemLink
                }
            >
                {navItem.displayName}
            </NavLink>
        </li>
    );
}
